var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588 313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 53.326C159.06.574 186.213 211.995 326.444 199.463 466.676 186.93 440.737 10.554 586 2",
    stroke: "#D4D4D4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,8"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-Bold, Montserrat",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#C61F2B",
    transform: "translate(46 2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8.565,
    y: 133
  }, "Moderated "), /*#__PURE__*/React.createElement("tspan", {
    x: 16.026,
    y: 155
  }, "profiles**")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#C61F2B",
    cx: 51,
    cy: 51,
    r: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 52.158a2.319 2.319 0 0 0-2.317 2.319v2.318a2.319 2.319 0 0 0 4.636 0v-2.318a2.319 2.319 0 0 0-2.318-2.319m5.59 11.077C54.823 64.5 52.873 65.89 51 67.533c-1.87-1.643-3.823-3.034-5.59-4.298-5.312-3.79-8.32-6.173-8.32-11.076a6.962 6.962 0 0 1 6.955-6.954c2.003 0 3.853.853 5.21 2.406.88 1.006 2.61 1.006 3.49 0 1.357-1.553 3.209-2.406 5.21-2.406a6.96 6.96 0 0 1 6.954 6.954c0 4.903-3.004 7.286-8.318 11.076ZM44.045 38.25A6.962 6.962 0 0 1 51 31.295a6.96 6.96 0 0 1 6.955 6.955v2.318A11.51 11.51 0 0 0 51 42.928a11.5 11.5 0 0 0-6.955-2.36V38.25Zm18.546 3.301V38.25c0-6.391-5.2-11.59-11.591-11.59-6.389 0-11.59 5.199-11.59 11.59v3.301c-4.086 1.792-6.955 5.867-6.955 10.608 0 7.53 5.218 11.25 10.262 14.85 2.251 1.607 4.579 3.267 6.644 5.334a2.32 2.32 0 0 0 3.278 0c2.068-2.067 4.395-3.727 6.646-5.334 5.045-3.6 10.26-7.32 10.26-14.85 0-4.74-2.867-8.816-6.954-10.608Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-Bold, Montserrat",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#C61F2B",
    transform: "translate(392 35)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54.1,
    y: 132
  }, "Secure"), /*#__PURE__*/React.createElement("tspan", {
    x: 39.439,
    y: 154
  }, "payments")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(428 35)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#C61F2B",
    cx: 51,
    cy: 51,
    r: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.857 28.933c1.198-1.486 2.986-1.486 4.17 0 1.09 1.34 2.193 2.696 3.267 4.052.243.294.438.392.827.278 1.674-.49 3.364-.932 5.051-1.389 1.788-.475 3.25.587 3.348 2.45.097 1.749.195 3.497.276 5.263.016.376.146.554.487.686l4.791 1.813c1.885.686 2.455 2.385 1.366 4.085a394.596 394.596 0 0 1-2.794 4.33c-.213.327-.23.554 0 .88.974 1.457 1.915 2.945 2.875 4.415 1.008 1.567.454 3.266-1.284 3.952-1.61.638-3.216 1.275-4.838 1.88-.344.132-.522.295-.538.703-.065 1.78-.163 3.547-.26 5.327-.097 1.815-1.576 2.893-3.331 2.418-1.72-.46-3.426-.916-5.133-1.387-.34-.097-.519 0-.73.26a405.272 405.272 0 0 1-3.282 4.117c-1.201 1.486-2.956 1.486-4.173 0a275.551 275.551 0 0 1-3.315-4.1c-.227-.277-.422-.344-.744-.244-1.642.473-3.315.848-4.94 1.37-2.047.654-3.556-.867-3.542-2.599.018-1.697-.16-3.398-.244-5.097-.014-.36-.127-.538-.487-.67a339.51 339.51 0 0 1-5.002-1.91c-1.61-.622-2.177-2.321-1.266-3.793a186.59 186.59 0 0 1 2.907-4.525c.21-.327.227-.554 0-.883a107.72 107.72 0 0 1-2.828-4.444c-1.006-1.551-.47-3.237 1.235-3.92a251.011 251.011 0 0 1 4.954-1.913c.327-.13.457-.294.473-.67.063-1.78.13-3.547.258-5.327.13-1.894 1.48-2.842 3.785-2.288l3.083.832c.46.127.93.258 1.398.394.424.13.684.065.976-.31 1.041-1.373 2.128-2.696 3.204-4.036Zm9.235 15.116h-.274a2.308 2.308 0 0 0-1.283.483l-.219.193-7.634 7.634-2.997-2.997a2.311 2.311 0 0 0-.963-.58l-.267-.064-.272-.032a2.312 2.312 0 0 0-1.776.676 2.316 2.316 0 0 0-.193 3.059l.193.219 4.636 4.636a2.31 2.31 0 0 0 1.343.66l.296.02.296-.02c.393-.05.776-.201 1.106-.453l.237-.207 9.273-9.273a2.316 2.316 0 0 0 0-3.278 2.31 2.31 0 0 0-1.23-.643l-.272-.033Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Montserrat-Bold, Montserrat",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#C61F2B",
    transform: "translate(236 140)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.308,
    y: 132
  }, "Protected "), /*#__PURE__*/React.createElement("tspan", {
    x: 34.89,
    y: 154
  }, "accounts ")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(263 140)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#C61F2B",
    cx: 51,
    cy: 51,
    r: 51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.227 49.456v-10.93L51 30.411l-16.227 8.113v10.93c0 10.275 6.938 19.768 16.227 22.332 9.289-2.564 16.227-12.057 16.227-22.331Zm3.355-14.438a2.318 2.318 0 0 1 1.282 2.075v12.363c0 12.552-8.735 24.148-20.315 26.979a2.314 2.314 0 0 1-1.098 0c-11.582-2.831-20.315-14.427-20.315-26.98V37.094c0-.879.496-1.683 1.282-2.075l18.546-9.273a2.313 2.313 0 0 1 2.072 0l18.546 9.273ZM45.684 49.362l2.998 2.997 7.634-7.634a2.316 2.316 0 0 1 3.277 0 2.316 2.316 0 0 1 0 3.278l-9.272 9.273a2.312 2.312 0 0 1-1.64.68 2.312 2.312 0 0 1-1.638-.68l-4.637-4.636a2.316 2.316 0 0 1 0-3.278 2.316 2.316 0 0 1 3.278 0Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.78958021a4d82920a736d477714fad59.svg";
export { ForwardRef as ReactComponent };